"use client";
import { hometestimonials, testimonials } from "@/data/testimonials";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import Link from "next/link";
export default function PayrollMSmainFeatures() {
  return (
    <div className="container position-relative">
      <div className="pt-80 pb-80 pt-sm-70 pb-sm-70 px-4 bg-gray-light-1">
        <div className="row">
          <div className="col-lg-12 -offset-lg-1 wow fadeInUp">
            <div className="row">
              <div className="col-md-10 offset-md-1 text-center">
                <h2 className="section-title mb-70 mb-sm-40">
                  {/* GetBiz Solutions is trusted by &nbsp;
                  <span className="mark-decoration-1">10,000+</span>
                  &nbsp;customers. */}
                  Key Highlights of Payroll Automation
                </h2>
              </div>
            </div>
            <div className="overflow-hidden">
              <Swiper
                rewind
                spaceBetween={0}
                slidesPerView={1}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".snbp2",
                  nextEl: ".snbn2",
                }}
                watchSlidesProgress
                resizeObserver
                style={{
                  opacity: 1,
                  display: "block",
                }}
                className="testimonials-slider-1 owl-carousel owl-theme pb-xs-80 overflow-visible position-static"
              >
                {/* {hometestimonials.map((testimonial, index) => (
                  <SwiperSlide className="owl-item" key={index}>
                    <div>
                      <blockquote className="mb-0">
                        <div className="blockquote-icon" aria-hidden="true">
                          ”
                        </div>
                        <p>{testimonial.quote}</p>
                        <div className="section-line mt-40" />
                        <footer className="ts1-author mt-20 clearfix">
                          <div className="overflow-hidden">
                            {testimonial.author}
                            <div className="small">{testimonial.role}</div>
                          </div>
                        </footer>
                      </blockquote>
                    </div>
                  </SwiperSlide>
                ))} */}
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={1200}
                          height={700}
                          src="/assets/images/img/product/hrms/payrollms/automated-salary-calculation.webp"
                          className="image-fullwidth relative"
                          alt="automated-salary-calculation"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/payroll-management-system/automated-salary-calculation" >
                            <h3 className="h3">Automated Salary Calculation</h3>
                          </Link>

                          <p className="text-gray">
                            Simplify and expedite salary calculations with automated systems that integrate attendance and performance data, ensuring precise and timely payroll management.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Real-time updates
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Overtime inclusion
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Time-tracking integration
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Performance-based adjustments

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={1200}
                          height={700}
                          src="/assets/images/img/product/hrms/payrollms/tax-and-compliance-management.webp"
                          className="image-fullwidth relative"
                          alt="tax-and-compliance-management"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/payroll-management-system/tax-and-compliance-management" >
                            <h3 className="h3">Compliance Management</h3>
                          </Link>

                          <p className="text-gray">
                            Stay up-to-date with evolving tax regulations and ensure complete compliance through automated tax updates and real-time compliance monitoring.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Tax automation
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Compliance alerts
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Regulatory updates
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Real-time checks
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>


                <div className="owl-controls clickable">
                  {/* <div className="owl-pagination">
                    <div className="owl-page">
                      <span className=""></span>
                    </div>
                    <div className="owl-page active">
                      <span className=""></span>
                    </div>
                  </div> */}
                  {/* owl-buttons */}
                  <div className=" text-center">
                    <div className="owl-prev snbp2" role="button" tabIndex="0">
                      <span className="visually-hidden">Previous Slide</span>
                      <i className="mi-arrow-left" aria-hidden="true"></i>
                    </div>
                    <div className="owl-next snbn2" role="button" tabIndex="0">
                      <span className="visually-hidden">Next Slide</span>
                      <i className="mi-arrow-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                {/* End Slide Item */}
              </Swiper>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
